// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2pUBH","tab":"Tabs_tab__1UKpE","tabActive":"Tabs_tabActive__GMS4z"};